import React from 'react';
import '../assets/styling/Home.css';
import '../assets/styling/ScrollAnimations.css';
import bgImg from '../assets/images/bg.jpg';
import Contact from '../components/Contact';
import Service from '../components/Service';
import About from '../components/About';
import Form from '../components/Form';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Home = () => {
  useScrollAnimation();

  return (
    <main className="main-wrapper">
      <section id="home" className="hero-section" style={{backgroundImage: `url(${bgImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}>
        <div className="container">
          <div className="hero-content">
            <div className="hero-title scroll-fade-up">
              <h1>Vino să transformi viziunile tale în realitate într-un mediu sigur și profesionist!</h1>
            </div>
            <div className="hero-bottom">
              <div className="hero-about">
                <div className="about-text scroll-fade-up delay-200">
                  <p style={{color: 'white', fontSize: '1.2rem'}}>
                    Fie ca vrei un podcast, un curs, tutoriale sau alte proiecte video, noi iti oferim un spațiu
                    flexibil și bine echipat pentru a-ți exprima creativitatea fără limite.
                  </p>
                </div>
                <div className="spacer"></div>
              </div>
              <div className="intl-email-row scroll-fade-up delay-300">
                <a href="#contact" className="social-link" style={{marginLeft: '8px'}}>
                  <div>Cere o ofertă</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section id="about" className="scroll-fade-up">
        <About />
      </section>

      <section id="services" className="scroll-fade-up">
        <Service />
      </section>

      <section id="form" className="scroll-fade-up">
        <div className="form-section-wrapper">
          <h2 className="form-section-title">Formular de Închiriere</h2>
          <p className="form-section-desc">Completează formularul de mai jos pentru a rezerva serviciile noastre</p>
          <Form />
        </div>
      </section>

      <section id="contact" className="scroll-fade-up">
        <Contact />
      </section>
    </main>
  );
};

export default Home; 